import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthenticationService } from '../../auth/services/authentication.service';
import { ProfileInfo } from '../../shared/models/profile-info';
import { DataService } from '../services/data-service.service';
import { JobInfo } from '../../jobs/models/job-info';

@Injectable({
  providedIn: 'root'
})
export class WizardStore {

  step: number = 1;

  private _selectedCandidateAccountId: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  public selectedCandidateAccountId: Observable<string> = this._selectedCandidateAccountId.asObservable();

  private _selectedJobId: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  public selectedJobId: Observable<string> = this._selectedJobId.asObservable();

  private _employerId: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  public employerId: Observable<string> = this._employerId.asObservable();

  private _applicantProfileInfos: BehaviorSubject<ProfileInfo[]> = new BehaviorSubject<ProfileInfo[]>([]);
  public applicantProfileInfos: Observable<ProfileInfo[]> = this._applicantProfileInfos.asObservable();

  private _selectedProfileInfo: BehaviorSubject<ProfileInfo> = new BehaviorSubject<ProfileInfo>(null);
  public selectedProfileInfo: Observable<ProfileInfo> = this._selectedProfileInfo.asObservable();

  private _selectedJob: BehaviorSubject<JobInfo> = new BehaviorSubject<JobInfo>(null);
  public selectedJob: Observable<JobInfo> = this._selectedJob.asObservable();

  constructor(private authService: AuthenticationService, private dataService: DataService) {
    this._employerId.next(authService.getAuthenticatedResult().accountId);
  }

  inviteCandidate(accountId: string): Promise<void> {
    const promise = new Promise<void>((resolve, reject) => {
      this.dataService.inviteCandidate(accountId, this.getSelectedJobId()).subscribe(s => {
        this._selectedCandidateAccountId.next(accountId);
        let selectedProfileInfo = this._applicantProfileInfos.getValue().find(pi => pi.accountId == accountId);
        if (selectedProfileInfo != null) {
          this._selectedProfileInfo.next(selectedProfileInfo);
        } else {
          this.dataService.getProfileInfo(accountId).subscribe(s => {
            if(!s) {
              return;
            }
            this._selectedProfileInfo.next(s);
          });
        }
        resolve();
      });
    });
    return promise;
  }

  setSelectedJobId(jobId: string): void {
    this._selectedJobId.next(jobId);
    this.getSelectedJobInfo(jobId);
  }

  getSelectedCandidateId(): string {
    return this._selectedCandidateAccountId.getValue();
  }

  getSelectedJobId(): string {
    return this._selectedJobId.getValue();
  }

  getEmployerId(): string {
    return this._employerId.getValue();
  }

  getCandidateProfileInfos(jobId: string): void {
    this.dataService.getProfileInfos(jobId).subscribe(s => {
      this._applicantProfileInfos.next(s);
      if (s.length > 0) {
        this._selectedCandidateAccountId.next(s[0].accountId);
      }
    });
  }

  getSelectedJobInfo(jobId: string): void {
    if (!jobId) {
      return;
    }

    this.dataService.getJobInfo(jobId).subscribe(j => {
      this._selectedJob.next(j);
    });
  }

}
